export default __webpack_public_path__ + "static/media/IMG_4904.86e23cbb.png";